module.exports = __webpack_public_path__ + "static/media/zeder_service.0f5195ba.png";